import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;

export default class LoanService {
	/**
	 * This function is used for do payment action ex: SKIP_AND_EXTEND.
	 * @return {}
	 */
	static async paymentAction(loanID, requestBody) {
		return ApiService.PostData(`${API_URLS.LOAN}/${loanID}/payment-action`, requestBody, 'loan');
	}

	static async get(url) {
		return ApiService.GetData(url, 'loan');
	}

	static async create(url, requestBody) {
		return ApiService.PostData(url, requestBody, 'loan');
	}

	static async update(url, requestBody) {
		return ApiService.PatchData(url, requestBody, 'loan');
	}

	static async delete(url) {
		return ApiService.DeleteData(url, 'loan');
	}

	static async updateDraftedLoan(id, loan) {
		return ApiService.PatchData(`${API_URLS.LOAN}/${id}/${API_URLS.DRAFTED_LOAN}`, loan, 'loan');
	}

	static async getUserLoansByUserId(userId, queryUrl) {
		return ApiService.GetData(`${API_URLS.LOAN_USERS}/${userId}${queryUrl}`, 'loan');
	}

	static async getModifiedLoans(loanId) {
		return ApiService.GetData(`${API_URLS.GET_MODIFIED_LOANS_BY_LOAN_ID}/${loanId}`, 'loan');
	}

	static async getAllLoansByUserId(userId, queryUrl) {
		return ApiService.GetData(`${API_URLS.LOAN_LIST_ALL_BY_USER}/${userId}${queryUrl}`, 'loan');
	}

	static async getLoan(loanId, instid = '') {
		return ApiService.GetData(`${API_URLS.LOAN}/${loanId}${instid ? `?installment_id=${instid}` : ''}`, 'loan');
	}

	static async guarantorRespondsInvite(requestBody) {
		return ApiService.PatchData(`${API_URLS.GUARANTOR_RESPONDS_INVITE}`, requestBody, 'loan');
	}

	static async getAllLoanInstallmentsByUserId(userId, queryUrl) {
		return ApiService.GetData(`${API_URLS.INSTALLMENTS_GET_ALL}/${userId}${queryUrl}`, 'default');
	}

	static async getDisbursalInstallments(userId, queryUrl) {
		return ApiService.GetData(`${API_URLS.GET_DISBURSAL_INSTALLMENTS}/${userId}/${queryUrl}`, 'default');
	}

	static async getOneInstallment(id) {
		return ApiService.GetData(`${API_URLS.INSTALLMENT_GET_ONE}/${id}`, 'default');
	}

	static async getFirstPayment(id) {
		return ApiService.GetData(`${API_URLS.INSTALLMENTS_GET_FIRST_PAYMENT}/${id}`, 'default');
	}
}
